import React, {Component} from 'react';
import { Row, Input, Icon } from 'react-materialize'
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'



class GenderSelector extends Component {
    onChangeGender(val){
      const { gender, onClickGender = () => {} } = this.props
       //if( gender.length === 1 && gender.includes(val)){
      //   if(gender.includes(val)){
      //     alert("One gender must be selected");
      //     return;
      //} else {
        this.props.onClickGender(val)
      //}
      // } else if ( gender.length === 2){
      //   if(!gender.includes(val)){
      //     alert("You can select up to 2 genders only")
      //     return;
      //   }
      // }
    }

    render(){
      const { gender, allGenders } = this.props
      return (
        <Row>
          {
            allGenders.map( collection =>
              gender.includes(collection)?
                <div className="gender-selector" onClick={()=> this.onChangeGender(collection)}><div className='checked'><FontAwesomeIcon icon="check"/></div>&nbsp;&nbsp;&nbsp;&nbsp;{collection}</div>:
                <div className="gender-selector" onClick={()=> this.onChangeGender(collection)}><div className='unchecked'/>&nbsp;&nbsp;&nbsp;&nbsp;{collection}</div> )
          }
          {/* {
            gender.includes('boys')? <div style={{display:'flex', alignSelf: "center"}} onClick={()=> this.onChangeGender("boys")}><Icon>check</Icon>Boys</div>:<div style={{display:'flex', alignSelf: "center"}} onClick={()=> this.onChangeGender("boys")}>
              <Icon>check_box_outline_blank</Icon>Boys</div>
            // gender.includes('boys')?<Input name='gender' type='checkbox' value='boys' label='Male' checked onClick={()=> onClickGender("boys")}/>:<Input name='gender' type='checkbox' value='boys' label='Male'
            //   onClick={()=> onClickGender("boys")}/>

          }
          {
            gender.includes('girls')? <div style={{display:'flex', alignSelf: "center"}} onClick={()=> this.onChangeGender("girls")}><Icon>check</Icon>Girls</div>:<div style={{display:'flex', alignSelf: "center"}} onClick={()=> this.onChangeGender("girls")}>
              <Icon>check_box_outline_blank</Icon>Girls</div>

            // gender.includes('girls')?<Input name='gender' type='checkbox' value='girls' label='Female' checked onClick={()=> onClickGender("girls")}/>:<Input name='gender' type='checkbox' value='girls' label='Female'
            //   onClick={()=> onClickGender("girls")}/>

          } */}
        </Row>
        );
      }
  }

  function mapStateToProps(state){
    return {
      allGenders: state.allGenders,
      gender: state.gender
    }
  };

  function mapDispatchToProps(dispatch){
    return {
      onClickGender: (gender) => dispatch({ type: 'ONCLICKGENDER', value: gender }),
    }
  }

  export default connect(mapStateToProps, mapDispatchToProps)(GenderSelector);


//export default GenderSelector;



// WEBPACK FOOTER //
// ./src/components/GenderSelector.js